import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { keyframes, css } from 'styled-components';
import { scrollY } from '@finect/tabular-utils/scrollY';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var show = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var animation = css(["animation:", " 0.2s ease;"], show);
export var OverBkg = styled.div.withConfig({
  displayName: "partials__OverBkg",
  componentId: "sc-mtvksp-0"
})(["position:fixed;z-index:999;top:0;bottom:0;left:0;right:0;background-color:rgb(0 0 0 / 0.4);", ";"], animation);
export var HelpBlock = styled.div.withConfig({
  displayName: "partials__HelpBlock",
  componentId: "sc-mtvksp-1"
})(["display:flex;position:fixed;z-index:10000;top:0;bottom:0;right:0;flex-flow:column;width:420px;box-shadow:-2px 0 3px 0 ", ";background-color:#fff;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
});
export var HeaderBlock = styled.div.withConfig({
  displayName: "partials__HeaderBlock",
  componentId: "sc-mtvksp-2"
})(["padding:18px 12px;h5:not(:last-child){padding-bottom:0;}"]);
export var BodyBlock = styled.div.withConfig({
  displayName: "partials__BodyBlock",
  componentId: "sc-mtvksp-3"
})(["flex-grow:1;padding:12px;background-color:", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiL;
}, scrollY);
export var CloseModal = styled.div.withConfig({
  displayName: "partials__CloseModal",
  componentId: "sc-mtvksp-4"
})([":hover{color:", ";}position:absolute;z-index:10000000;top:18px;right:18px;cursor:pointer;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    top: 15px;\n    right: 15px;\n  "]))));